import { TrendingUp, Users, DollarSign, Stethoscope } from "lucide-react";
import { formatBRL, PLAN_META, STATUS_META } from "@/data/backofficeData";

const Kpi = ({ icon: Icon, label, value, hint, tint }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid={`bo-kpi-${label}`}>
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-slate-500">{label}</span>
      <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${tint}`}>
        <Icon className="h-4 w-4" strokeWidth={2.2} />
      </div>
    </div>
    <p className="mt-3 font-heading text-2xl font-extrabold text-slate-900 font-mono-num">{value}</p>
    {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
  </div>
);

export const Overview = ({ customers, leads }) => {
  const mrr = customers.filter((c) => c.status === "ativo").reduce((s, c) => s + c.mrr, 0);
  const consultas = customers.reduce((s, c) => s + c.consultasMes, 0);
  const ativos = customers.filter((c) => c.status === "ativo").length;
  const pipeline = leads.filter((l) => l.stage !== "perdido" && l.stage !== "ganho").reduce((s, l) => s + l.value, 0);

  return (
    <div className="space-y-6" data-testid="bo-overview">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <Kpi icon={DollarSign} label="MRR (Receita Recorrente)" value={formatBRL(mrr)} hint="Assinantes ativos" tint="bg-emerald-50 text-emerald-600" />
        <Kpi icon={Users} label="Clientes Ativos" value={ativos} hint={`${customers.length} contas no total`} tint="bg-blue-50 text-blue-600" />
        <Kpi icon={Stethoscope} label="Consultas no Mês" value={consultas.toLocaleString("pt-BR")} hint="Somatório da base" tint="bg-violet-50 text-violet-600" />
        <Kpi icon={TrendingUp} label="Pipeline Aberto" value={formatBRL(pipeline)} hint={`${leads.length} leads no funil`} tint="bg-amber-50 text-amber-600" />
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <h3 className="font-heading text-sm font-bold text-slate-900">Distribuição por Plano</h3>
          <div className="mt-4 space-y-3">
            {Object.entries(PLAN_META).map(([key, meta]) => {
              const count = customers.filter((c) => c.plan === key).length;
              const pct = customers.length ? (count / customers.length) * 100 : 0;
              return (
                <div key={key}>
                  <div className="flex items-center justify-between text-xs font-medium text-slate-600">
                    <span>{meta.label}</span>
                    <span className="font-mono-num">{count}</span>
                  </div>
                  <div className="mt-1 h-2 overflow-hidden rounded-full bg-slate-100">
                    <div className="h-full rounded-full bg-slate-900" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <h3 className="font-heading text-sm font-bold text-slate-900">Saúde da Base</h3>
          <div className="mt-4 grid grid-cols-2 gap-3">
            {Object.entries(STATUS_META).slice(0, 3).map(([key, meta]) => {
              const count = customers.filter((c) => c.status === key).length;
              return (
                <div key={key} className={`rounded-xl border p-4 ${meta.color}`}>
                  <p className="font-heading text-2xl font-extrabold font-mono-num">{count}</p>
                  <p className="text-xs font-medium">{meta.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
